import type { FaireThemeEntity } from "../../entity_types/theme";

export const scandi_hygge_kitchen_cookbooks: FaireThemeEntity = {
  token: "scandi-hygge-kitchen-cookbooks",
  type: "theme",
  name: "Scandi Hygge Kitchen + Cookbooks",
  description: "",
  teaser: "",
  detail: "",
  bgColor: "#D4EBD4",
  exactProducts: true,
  retailerToken: "r_eer7xgiweo",
  productTokens: [
    "p_8zc4pppspq",
    "p_qfe5zdjmt4",
    "p_x694j7aqcu",
    "p_hcez9wag3h",
    "p_tc9nhzp7a6",
    "p_zpnr33t57v",
    "p_g9wvd77syf",
    "p_vwe6gtymas",
    "p_fqtneesw33",
    "p_9m5w3k7mje",
    "p_nr3ddhuzkf",
    "p_d8n823nuq4",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
